var pjax = require('./lib/pjax'),
	moment = require('moment'),
	gtm = require('./lib/gtm-events'),
	_ = require('lodash');

document.addEventListener('latte:init', init);

function init() {
	//event slice tab function
	$('.test--tab').click(function (e) {
		var tabName = $(this).attr('data-tabName');
		pjax.loadUrl(helper.currentURLWithoutQS() + '?' + 'event-tab=' + tabName); //will refresh the content container
	});

	$('.event--filter').change(function (e) {
		var eventType = $(this).attr('data-event-type');

		var eType = '',
			tab = '',
			finalParam = '';

		if (helper.getUrlParameter('event-tab')) {
			tab = helper.getUrlParameter('event-tab');
		}

		if (location.search.split('eventTypes=')[1] !== undefined) {
			eType = helper.getUrlParameter('eventTypes');
			eType = decodeURIComponent(eType).split(',');
		} else {
			eType = eType.substring(0, eType.length - 1);
			eType = $('#eventfilter')
				.attr('data-event-type-string')
				.split(',');
		}

		if (this.checked) {
			$("div[data-event-type='" + eventType + "']").show();
			eType.push(eventType);
		} else {
			$("div[data-event-type='" + eventType + "']").hide();
			eType.splice(eType.indexOf(eventType), 1);
		}

		//if event-tab exist then we add it;
		if (tab) {
			finalParam += 'event-tab=' + tab;
		}
		//all param related to event type
		if (eType) {
			if (finalParam) {
				finalParam += '&eventTypes=' + eType;
			} else {
				finalParam += 'eventTypes=' + eType;
			}
		}

		history.pushState(null, null, '?' + finalParam);

		if ($('#eventfilter input:checkbox:checked').length > 0) {
			$('.no-selection').hide();
		} else {
			$('.no-selection').show();
		}
	});

	//on event row click
	$('.event-row').click(function (e) {
		updateEventModelData($(this).find('.eventDetail').find('a'));
	});

    /**
     * These variable & `updateEventModelData` function is use both special and free event model to bind data together
     */
	var eventName, eventStartMonth, eventStartDay, eventTime, eventCode, eventDescription, eventId, liveOnlineClass, eventStartDate, eventEndDate, eventStartTime,
		eventAddress, eventAddress2, eventCity, eventState, eventZip, eventFacility, eventEndTime, leadSource, facility, formatDistance, eventType, url;
	function updateEventModelData(data) {
		eventName = data.attr('data-event-name');
		eventStartMonth = data.attr('data-event-month');
		eventStartDay = data.attr('data-event-date');
		eventDayofWeek = moment(data.attr('data-event-daysOfWeek'), 'dddd').format('dddd');
		eventTime = data.attr('data-event-startTime') + ' - ' + data.attr('data-event-endTime') + (data.attr('data-event-liveOnlineClass') ? ' ET' : '');
		eventCode = data.attr('data-event-code');
		eventDescription = data.attr('data-event-description');
		eventId = data.attr('data-event-id');
		liveOnlineClass = data.attr('data-event-liveOnlineClass') == 'true'; //Convert string to boolean
		eventStartDate = data.attr('data-event-startDate'); // use by add to calendar
		eventEndDate = data.attr('data-event-endDate'); // use by add to calendar
		eventStartTime = data.attr('data-event-startTime');
		eventEndTime = data.attr('data-event-endTime');
		leadSource = data.attr('data-event-leadSource'); //regular event will NOT have lead source
		eventAddress = data.attr('data-facility-address') && data.attr('data-facility-address') !== '' ? data.attr('data-facility-address') + ', ' : '';
		eventAddress2 = data.attr('data-facility-address2') && data.attr('data-facility-address2') !== '' ? data.attr('data-facility-address2') + ', ' : '';
		eventCity = data.attr('data-facility-city') && data.attr('data-facility-city') !== '' ? data.attr('data-facility-city') + ', ' : '';
		eventState = data.attr('data-facility-state') && data.attr('data-facility-state') !== '' ? data.attr('data-facility-state') + ' ' : '';
		eventZip = data.attr('data-facility-zip') && data.attr('data-facility-zip') !== '' ? data.attr('data-facility-zip') : '';
		eventFacility = data.attr('data-facility-name') && data.attr('data-facility-name') !== '' ? data.attr('data-facility-name') + ' - ' : '';
		facility = eventFacility + eventAddress + eventAddress2 + eventCity + eventState + eventZip;
		formatDistance = Math.round(data.attr('data-facility-distance'));
		eventType = data.attr('data-event-type');
		url = data.attr('data-href'); // always setup to simpleSignUp url

		$('.event-modal--title').text(eventName);
		$('.event-modal--dayOfWeek').text(eventDayofWeek);
		$('.event-modal--startDate').text(eventStartDate);
		$('.event-modal--start-month').text(eventStartMonth);
		$('.event-modal--start-day').text(eventStartDay);
		$('.event-modal--time').text(eventTime);
		$('.event-modal--classCode').text(eventCode);
		$('.event-description--link')
			.find('a')
			.attr('data-event-id', eventId); //add to event id to 'more detail link as well'
		$('.event-description--link')
			.find('a')
			.attr('data-event-leadSource', leadSource); //add to lead Source to 'more detail link as well'
		$('.event-description--link')
			.find('a')
			.attr('href', '/class/' + eventCode); //go to event detail page
		$('.event-modal--description').text(eventDescription);

		//liveOnlineClass vs onSite address logic
		if (liveOnlineClass) {
			$('.event-modal--location .location').hide();
			$('.event-modal--location .distance').text('Online');
		} else {
			$('.event-modal--location .location').show();
			$('.event-modal--location .location').text(facility);
			$('.event-modal--location .link').attr('href', link.gLink + facility);
			if (formatDistance > 0) {
				$('.event-modal--location .distance').text(' | ' + formatDistance + ' miles away');
			}
		}

		//simpleSignUp model button logic
		$('.eventSignUp')
			.find('a')
			.attr('data-event-id', eventId);
		$('.eventSignUp')
			.find('a')
			.attr('data-event-leadSource', leadSource);
		$('.eventSignUp')
			.find('a')
			.attr('href', link.simpleSignUp + eventId);
	}

	//Signup bottom click both on page and model
	$('.signUpEvent').click(function () {
		var eventClassId = $(this).attr('data-event-id');
		var leadSource = $(this).attr('data-event-leadSource');
		if (sessionStorage) {
			sessionStorage.setItem('freeEvent_redirectURL_' + eventClassId, window.location.href);
			sessionStorage.setItem('freeEvent_leadSource_' + eventClassId, leadSource);

			window.location.href = link.simpleSignUp + eventClassId; //redirect to simple sign up
		}
	});

	// model 'more detail' link click we drop return url
	$('.event-description--link').click(function (e) {
		if (sessionStorage) {
			var eventClassId = $(this)
				.find('a')
				.attr('data-event-id');
			var leadSource = $(this)
				.find('a')
				.attr('data-event-leadsource');
			sessionStorage.setItem('freeEvent_redirectURL_' + eventClassId, window.location.href);
			if (leadSource !== '') {
				sessionStorage.setItem('freeEvent_leadSource_' + eventClassId, leadSource);
			}
		}
	});

	//on mobile we move the modal trigger attribute to event-row
	if (window.innerWidth <= 640) {
		$('.event-row').attr('data-open', 'signupform');
		$('.eventSlice').addClass('event-row');
	} else {
		$('.event-row').removeAttr('data-open', 'signupform');
		$('.eventSlice').removeClass('event-row');
	}
}



//////////////////
// WEBPACK FOOTER
// ./public/js/events.js
// module id = 72
// module chunks = 0